if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

	//for Menus
    document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
        btn.addEventListener('click', _ => {
            document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            document.querySelectorAll('.menu__unitmenu').forEach(room => {
                room.classList.remove('active');
                if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
                    room.classList.add('active');
                }
            });
        });

        if (i === 0) btn.click();
    });

	$('.menu-restaurant__tabs').each((i, dots) => {
        $('.menu-restaurant__tab', dots).click((e) => {
            let slideTo = $(e.currentTarget).data('goto');
            $('.top-content__slider').slick('slickGoTo', slideTo);
        });
    });

    
    
    window.addEventListener('load', () => {
        document.querySelectorAll('#email-signup .field.input input').forEach( field => {
            field.addEventListener('blur', () => {
                console.log(field.value);
                if (field.value) {
                    localStorage.setItem(`${field.name}`,`${field.value}`);
                }                    
            });
        });
        
        document.querySelectorAll('#form_id-4385 .form-module__field input').forEach( field => {
            for (let key in localStorage){                
                if( key == field.name && localStorage.getItem(key) != null){
                    field.value = localStorage.getItem(key);
                }
            }
            
        });
    });
})();

(function() {
    const form = document.querySelector('form');
    if (form) {
        const countrySelect = form.querySelector('select[name="country"]');
        const zipCodeInput = form.querySelector('input[name="zip_code"]');
        const checkbox = form.querySelector('input[name="subscribe"]');

        if (countrySelect && zipCodeInput) {
            checkbox.classList.add('required');
            countrySelect.addEventListener('change', (event) => {
                if (event.target.value === 'US') {
                    zipCodeInput.classList.add('required');
                } else {
                    zipCodeInput.classList.remove('required');
                }
            });
        }
    }

})();

$( ".form-module-wrapper p, .form-module-wrapper form").wrapAll( "<div class='wrap-form animate-fade top'></div>" );

	// validation icon sound
	const IcoVideoAct = document.querySelectorAll('#IcoVideoHome')[0];
	const IcoVideoDes = document.querySelectorAll('#IcoVideoHomeDes')[0];

	if (IcoVideoAct != null) {
		IcoVideoAct.addEventListener('click', soundVideo);
	} 
	if (IcoVideoDes != null) {
		IcoVideoDes.addEventListener('click', soundVideoOff);
	}
	function soundVideo(e) {
		const video = document.querySelectorAll("#homevideo")[0];
		video.muted = false; 
		e.target.classList.add('hidden');
		IcoVideoDes.classList.remove('hidden');
	}
	function soundVideoOff(e) {
		const video = document.querySelectorAll("#homevideo")[0];
		video.muted = true;
		e.target.classList.add('hidden');
		IcoVideoAct.classList.remove('hidden'); 
	}